import { render, staticRenderFns } from "./mainSlider.vue?vue&type=template&id=f0210ac8&"
import script from "./mainSlider.vue?vue&type=script&lang=js&"
export * from "./mainSlider.vue?vue&type=script&lang=js&"
import style0 from "./mainSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports